export { default as DeleteModal } from './delete-modal-select';
export {
  default as DeleteRowsSelectAdmin,
  type IRowsToDelete
} from './delete-rows-select';

export { default as AdminMobileMenu } from './admin-mobile-menu';
